<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-title primary-title>
        <div>
          <h5 class="title mb-0">Recebimento Empresas</h5>
        </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-flex>
      <v-data-table
        hide-actions
        :loading="loading"
        :items="meios_recebimento"
        :hide-headers="!meios_recebimento.length"
        class="elevation-1"
      >
        <template v-slot:headers>
          <tr>
            <th></th>
            <th class="text-xs-left">Descrição</th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td style="width: 10px">
              <v-icon color="success">check_circle_outline</v-icon>
            </td>
            <td  class="text-xs-left" >{{ props.item.descricao }}</td>
            <td>
              <v-btn icon @click="deletarMeio(props.item.id)">
                <v-icon color="error">delete</v-icon>
              </v-btn>
              <v-btn icon @click="visualizarMeio(props.item)">
                <v-icon color="info">remove_red_eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
    <v-dialog v-if="dialog" v-model="dialog" width="500">
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title class="white--text">{{meio_selecionado.descricao}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <h2 style="width: 100%; text-align: center;" v-if="meio_selecionado.chave_pix">Chave PIX: {{meio_selecionado.chave_pix}}</h2>
          <h2 style="width: 100%; text-align: center;" v-if="meio_selecionado.cod_boleto">Código do Boleto: {{meio_selecionado.cod_boleto}}</h2>
          <h2 style="width: 100%; text-align: center;" v-if="meio_selecionado.banco">{{meio_selecionado.banco}}</h2>
          <h3 v-if="meio_selecionado.agencia">Agencia: {{meio_selecionado.agencia}}</h3>
          <h3 v-if="meio_selecionado.conta">Conta: {{meio_selecionado.conta}}</h3>
          <h3 v-if="meio_selecionado.tipo_conta">{{tipos_conta[meio_selecionado.tipo_conta - 1].descricao}}</h3>
          <h2 style="width: 100%; text-align: center;" v-if="meio_selecionado.tipo == 4">Aceita cartão de crédito</h2>
          <h2 style="width: 100%; text-align: center;" v-if="meio_selecionado.tipo == 5">Aceita cartão de débito</h2>
        </v-card-text>
        <v-card-actions>
          <v-btn block @click="dialog=false" color="primary">fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>

export default {
  data () {
    return {
      dialog: false,
      meio_selecionado: null,
      teste: true,
      tipos_conta: [
        { descricao: 'Conta Corrente', 'id': 1 },
        { descricao: 'Conta Poupança', 'id': 2 },
        { descricao: 'Conta Conjunta', 'id': 3 },
        { descricao: 'Conta Salário', 'id': 4 }
      ]
    }
  },
  mounted () {
    if (this.posto) {
      this.$store.dispatch('pegarMeioRecebimento')
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    posto () {
      return this.$store.getters.posto
    },
    meios_recebimento () {
      return this.$store.getters.meios_recebimento
    }
  },
  methods: {
    visualizarMeio (meio) {
      this.meio_selecionado = meio
      this.dialog = true
    },
    deletarMeio (id) {
      this.$store.dispatch('deletarMeioRecebimento', { id: id }).then(this.$store.dispatch('pegarMeioRecebimento'))
    }
  },
  watch: {
    posto (val) {
      if (val) {
        this.$store.dispatch('pegarMeioRecebimento')
      }
    }
  }
}
</script>
